"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.path = exports.requestSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const shared_types_1 = require("../../shared-types");
exports.requestSchema = zod_1.default.array(shared_types_1.IrrigationScheduler.scheduledEventInputSchema);
exports.path = '/irrigation-scheduler-events-update';
//# sourceMappingURL=index.js.map